export const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsent';
export const COOKIE_CONSENT_VERSION = 1;

export const DEFAULT_COOKIE_PREFERENCES = {
  essential: true,
  analytics: false,
  marketing: false,
};

/** Rotas internas onde o banner de cookies não é exibido. */
export function isInternalAdminRoute(pathname = '') {
  return (
    pathname === '/admin' ||
    pathname.startsWith('/admin/') ||
    pathname === '/master' ||
    pathname.startsWith('/master/')
  );
}

export function normalizeCookiePreferences(preferences = {}) {
  return {
    essential: true,
    analytics: Boolean(preferences.analytics),
    marketing: Boolean(preferences.marketing),
  };
}

export function getStoredCookieConsent() {
  if (typeof window === 'undefined') return null;

  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== COOKIE_CONSENT_VERSION) return null;

    return {
      answeredAt: parsed.answeredAt || null,
      preferences: normalizeCookiePreferences(parsed.preferences),
    };
  } catch {
    return null;
  }
}

export function saveCookieConsent(preferences) {
  const payload = {
    version: COOKIE_CONSENT_VERSION,
    answeredAt: new Date().toISOString(),
    preferences: normalizeCookiePreferences(preferences),
  };

  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function hasCookieConsentAnswer() {
  return Boolean(getStoredCookieConsent()?.answeredAt);
}
